import { defineComponent, computed, ref, getCurrentInstance, isVue2 } from 'vue-demi';
import { useMounted } from '@vueuse/core';
import { OrMenuV3, OrMenuItemV3, OrIconButtonV3, useOverflow } from '@onereach/ui-components';
import { resolveComponent, openBlock, createBlock, withCtx, createElementVNode, normalizeClass, toDisplayString, createElementBlock, Fragment, renderList, createVNode, createCommentVNode, createTextVNode } from 'vue';

function arrayMove(array, from, to, on = 1) {
  return array = array.slice(), array.splice(to, 0, ...array.splice(from, on)), array;
}

const menuItemStylesBase = ['flex', 'typography-caption-bold', 'whitespace-nowrap', 'rounded-[12px]', 'bg-transparent', 'px-sm+ py-xs*'];
const menuItemStyles = [...menuItemStylesBase, 'text-white',
// active
'selected:bg-white', 'selected:text-black'];
const menuItemInvertedStyles = [...menuItemStylesBase, 'text-black dark:text-white',
// active
'selected:bg-black', 'selected:text-white'];

var script$1 = defineComponent({
  name: 'ServiceNavigationMenuItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    inverted: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const itemStyles = computed(() => [...(props.inverted ? menuItemInvertedStyles : menuItemStyles)]);
    return {
      itemStyles
    };
  },
  computed: {
    external() {
      return this.item.url.startsWith('http');
    }
  }
});

const _hoisted_1$1 = ["href", "selected", "inverted", "onClick"];
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = resolveComponent("router-link");
  return openBlock(), createBlock(_component_router_link, {
    to: _ctx.item.url,
    custom: ""
  }, {
    default: withCtx(({
      href,
      navigate
    }) => [createElementVNode("a", {
      href: _ctx.external ? _ctx.item.url : href,
      class: normalizeClass(_ctx.itemStyles),
      selected: _ctx.active,
      inverted: _ctx.inverted,
      onClick: e => !_ctx.external && navigate(e)
    }, toDisplayString(_ctx.item.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_1$1)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["to"]);
}

script$1.render = render$1;
script$1.__file = "src/components/ServiceNavigationMenu/ServiceNavigationMenuItem.vue";

var script = defineComponent({
  name: 'ServiceNavigationMenu',
  components: {
    OrMenu: OrMenuV3,
    OrMenuItem: OrMenuItemV3,
    OrIconButton: OrIconButtonV3,
    ServiceNavigationMenuItem: script$1
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    inverted: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const container = ref();
    const menuTrigger = ref();
    const outsideItemMenu = ref();
    const instance = getCurrentInstance();
    const {
      innerItems,
      outerItems
    } = useOverflow(container, {
      threshold: 8
    });
    const isMounted = useMounted();
    function isActive(url) {
      var _a, _b, _c, _d;
      if (instance && !url.startsWith('http')) {
        if (isVue2) {
          // @ts-ignore
          return ((_a = instance.proxy) === null || _a === void 0 ? void 0 : _a.$route).path.startsWith(url);
        }
        // @ts-ignore
        return (_d = (_c = (_b = instance.proxy) === null || _b === void 0 ? void 0 : _b.$router) === null || _c === void 0 ? void 0 : _c.currentRoute) === null || _d === void 0 ? void 0 : _d.value.path.startsWith(url);
      }
      return false;
    }
    const activeIndex = computed(() => {
      if (isMounted.value) {
        return props.items.findIndex(({
          url
        }) => isActive(url));
      }
      return 0;
    });
    const orderedItems = computed(() => {
      if (outerItems.value.length > 0 && activeIndex.value >= innerItems.value.length) {
        return arrayMove(props.items, activeIndex.value, innerItems.value.length - 1);
      }
      return props.items;
    });
    const hiddenItems = computed(() => {
      return orderedItems.value.slice(innerItems.value.length);
    });
    return {
      outsideItemMenu,
      container,
      isActive,
      orderedItems,
      activeIndex,
      menuTrigger,
      innerItems,
      outerItems,
      hiddenItems
    };
  }
});

const _hoisted_1 = {
  class: "container flex justify-around"
};
const _hoisted_2 = {
  class: "layout-row overflow-hidden"
};
const _hoisted_3 = {
  ref: "container",
  class: "layout-row max-w-full gap-[40px] overflow-hidden py-xs"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ServiceNavigationMenuItem = resolveComponent("ServiceNavigationMenuItem");
  const _component_OrIconButton = resolveComponent("OrIconButton");
  const _component_or_menu_item = resolveComponent("or-menu-item");
  const _component_router_link = resolveComponent("router-link");
  const _component_or_menu = resolveComponent("or-menu");
  return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [createElementVNode("div", _hoisted_3, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.orderedItems, item => {
    return openBlock(), createElementBlock("div", {
      key: item.label,
      ref_for: true,
      ref: "menu-items",
      "data-test": "menu-item"
    }, [createVNode(_component_ServiceNavigationMenuItem, {
      item: item,
      active: _ctx.items[_ctx.activeIndex] && item.url === _ctx.items[_ctx.activeIndex].url,
      inverted: _ctx.inverted
    }, null, 8 /* PROPS */, ["item", "active", "inverted"])]);
  }), 128 /* KEYED_FRAGMENT */))], 512 /* NEED_PATCH */), _ctx.hiddenItems.length ? (openBlock(), createBlock(_component_OrIconButton, {
    key: 0,
    ref: "menuTrigger",
    icon: "more_horiz",
    class: normalizeClass([_ctx.inverted ? 'text-black' : 'text-white']),
    color: "inherit",
    "force-state": _ctx.outsideItemMenu && _ctx.outsideItemMenu.state === 'open' ? 'active' : undefined,
    "data-test": "menu-more-trigger",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.outsideItemMenu && _ctx.outsideItemMenu.toggle())
  }, null, 8 /* PROPS */, ["class", "force-state"])) : createCommentVNode("v-if", true)]), createVNode(_component_or_menu, {
    ref: "outsideItemMenu",
    placement: "bottom",
    trigger: _ctx.menuTrigger
  }, {
    default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.hiddenItems, item => {
      return openBlock(), createBlock(_component_router_link, {
        key: item.label,
        to: item.url,
        custom: ""
      }, {
        default: withCtx(({
          navigate
        }) => [createVNode(_component_or_menu_item, {
          onClick: navigate
        }, {
          default: withCtx(() => [createTextVNode(toDisplayString(item.label), 1 /* TEXT */)]),

          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]);
    }), 128 /* KEYED_FRAGMENT */))]),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["trigger"])]);
}

script.render = render;
script.__file = "src/components/ServiceNavigationMenu/ServiceNavigationMenu.vue";

export { script as s };
